/**
 * Único punto de escritura de globals legacy en `window`.
 * El código moderno debe leer vía `@/legacy/globals` (Proxies), no tocar `window` a mano.
 */

const ALLOWED_KEYS = [
  '$',
  'jQuery',
  '_',
  'moment',
  'Backbone',
  'Marionette',
  'Mn',
  'toastr',
  'swal',
  'I18n',
  'Cifra',
  'JST',
  'Chart',
  'ChartDataLabels',
  'ChartRenderer',
  'Stimulus',
];

/**
 * Esqueleto mínimo antes del concat classic-scope.
 */
export function registerGlobalsSkeleton() {
  if (!window.Cifra || typeof window.Cifra !== 'object') {
    window.Cifra = {};
  }
  if (!window.JST || typeof window.JST !== 'object') {
    window.JST = {};
  }
}

/**
 * jQuery (cualquier major) → window.$ / window.jQuery.
 */
export function registerJquery(jQuery) {
  window.jQuery = jQuery;
  window.$ = jQuery;
  return jQuery;
}

export function registerLodash(lodash) {
  // backbone.syphon 0.6.x usa API underscore (`_.include`); lodash 4 solo tiene `includes`.
  if (!lodash.include && lodash.includes) {
    lodash.include = lodash.includes;
  }
  window._ = lodash;
  return lodash;
}

export function registerMoment(momentLib) {
  window.moment = momentLib;
  return momentLib;
}

export function registerBackbone(Backbone, { Radio, Marionette } = {}) {
  window.Backbone = Backbone;
  if (Radio) {
    Backbone.Radio = Radio;
  }
  if (Marionette) {
    window.Marionette = Marionette;
    window.Mn = Marionette;
  }
  return Backbone;
}

export function registerToastr(toastrLib) {
  window.toastr = toastrLib;
  return toastrLib;
}

/** Instancia i18n-js → window.I18n (bridge JST / classic-scope). */
export function registerI18n(i18nInstance) {
  window.I18n = i18nInstance;
  return i18nInstance;
}

/**
 * Aliases y namespaces tras cargar UMD / classic scope.
 */
export function syncGlobalsFromWindow() {
  registerGlobalsSkeleton();
  if (window.Marionette && !window.Mn) {
    window.Mn = window.Marionette;
  }
  if (window.Mn && !window.Marionette) {
    window.Marionette = window.Mn;
  }
  if (window.jQuery && !window.$) {
    window.$ = window.jQuery;
  }
  if (window.$ && !window.jQuery) {
    window.jQuery = window.$;
  }
}

/**
 * Namespaces Cifra usados por el concat Marionette.
 */
export function ensureCifraAppNamespace() {
  syncGlobalsFromWindow();
  const c = window.Cifra;
  c.Shared ||= {};
  c.Models ||= {};
  c.Collections ||= {};
  c.Channels ||= {};
  c.Components ||= {};
  if (!c.Modals && typeof c.ModalsManager === 'function') {
    c.Modals = new c.ModalsManager();
  }
}

/**
 * Publica APIs ESM en el namespace legacy (consumidores: JS en app/assets).
 * Documentado en doc/frontend/LEGACY_BRIDGE.md.
 */
export function registerCifraApi(apiMap) {
  syncGlobalsFromWindow();
  window.Cifra.Api = { ...(window.Cifra.Api || {}), ...apiMap };
}

/**
 * Stimulus solo en desarrollo (inspección en consola).
 */
export function registerStimulusDebug(stimulusApp) {
  if (import.meta.env.DEV) {
    window.Stimulus = stimulusApp;
  }
}

/**
 * Asigna componentes/libs modernas bajo Cifra (shell).
 */
export function registerCifraShellExtras({ Overlay, http }) {
  syncGlobalsFromWindow();
  window.Cifra.Components ||= {};
  if (Overlay) {
    window.Cifra.Components.Overlay = Overlay;
  }
  if (http) {
    window.Cifra.Libs = { http };
  }
}

/** Lista de claves que el puente puede escribir en window (documentación / lint). */
export function allowedWindowGlobalKeys() {
  return [...ALLOWED_KEYS];
}
